!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("@material-ui/core"), require("@material-ui/core/styles"), require("@material-ui/styles"), require("classnames"), require("react")) : "function" == typeof define && define.amd ? define(["exports", "@material-ui/core", "@material-ui/core/styles", "@material-ui/styles", "classnames", "react"], t) : t((e = e || self)["tablet-button"] = {}, e.core, e.styles, e.styles$1, e.classNames, e.React);
}(this, function (e, t, r, a, o, n) {
  "use strict";

  o = o && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o, n = n && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;

  var _l = function l() {
    return (_l = Object.assign || function (e) {
      for (var t, r = 1, a = arguments.length; r < a; r++) for (var o in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);

      return e;
    }).apply(this, arguments);
  };

  var i = n.forwardRef(function (e, i) {
    var d = e.variant,
        s = void 0 === d ? "text" : d,
        c = e.color,
        u = e.disabled,
        p = e.children,
        f = function (e, t) {
      var r = {};

      for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (a = Object.getOwnPropertySymbols(e); o < a.length; o++) t.indexOf(a[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[o]) && (r[a[o]] = e[a[o]]);
      }

      return r;
    }(e, ["variant", "color", "disabled", "children"]),
        b = function (e, t) {
      return a.makeStyles(function (o) {
        var n = e && "default" !== e ? e : void 0,
            l = {
          text: {
            borderRadius: 48,
            backgroundColor: "transparent",
            color: n ? o.palette[n].main : void 0,
            "&:hover": {
              backgroundColor: n ? r.fade(o.palette[n].main, .08) : r.fade(o.palette.common.black, .08)
            }
          },
          outlined: {
            borderRadius: 48,
            backgroundColor: "transparent",
            borderStyle: "solid",
            borderWidth: 1,
            borderColor: n && !t ? o.palette[n].main : o.palette.grey[400],
            color: n ? o.palette[n].main : void 0,
            "&:hover": {
              backgroundColor: n ? r.fade(o.palette[n].main, .1) : r.fade(o.palette.common.black, .08)
            }
          },
          contained: {
            borderRadius: 48,
            backgroundColor: t ? o.palette.grey[300] : n ? o.palette[n].main : void 0,
            color: n ? o.palette.getContrastText(o.palette[n].main) : void 0,
            "&:hover": {
              backgroundColor: n ? r.darken(o.palette[n].dark, .08) : void 0
            }
          }
        };
        return a.createStyles(l);
      })();
    }(c, u);

    if (!a.useTheme()) throw new Error("TabletButton requires a Material-UI Theme");
    return n.createElement(t.Button, _l({
      ref: i,
      size: "small"
    }, f, {
      disabled: u,
      className: o(e.className, "text" === s ? b.text : "outlined" === s ? b.outlined : b.contained),
      style: _l({
        textTransform: "none",
        boxShadow: "none",
        paddingLeft: 21,
        paddingRight: 21
      }, e.style)
    }), p);
  });
  e.TabletButton = i, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});